import { NumberInput, NumberInputProps } from '@mantine/core'
import React from 'react'

export default function EPhoneInput(props: NumberInputProps) {
  return (
    <NumberInput
      {...props}
      styles={{
        input: {
          borderRadius: '8px',
          fontSize: '17px',
        },
        label: {
          marginBottom: '2px',
          fontWeight: 400,
          fontSize: '15px',
          color: '#374151',
        },
        error: {
          fontSize: '12px',
          marginTop: '4px',
        },
        ...props.styles as any,
      }}
      hideControls={props.hideControls ? props.hideControls : true}
      value={props.value || ""}
      leftSection={<div>+91</div>}
      min={props.min ? props.min : 0}
      maxLength={10}
    />
  )
}